import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import type { DashboardKpis } from '../api/types';

export function useDashboardKpis() {
  return useQuery({
    queryKey: ['kpis'],
    queryFn: () => api.get<DashboardKpis>('/dashboard/kpis').then((r) => r.data),
    refetchInterval: 30_000,
  });
}
